export interface IOtaReservationEditPermissionsResponse {
  can_update_ota_reservation: boolean
  can_update_memo: boolean
}

export interface IOtaReservationEditPermissions {
  canUpdateOtaReservation: boolean
  canUpdateMemo: boolean
}

export const formatEditPermissions = (
  permissions: IOtaReservationEditPermissionsResponse
): IOtaReservationEditPermissions => ({
  canUpdateOtaReservation: permissions.can_update_ota_reservation,
  canUpdateMemo: permissions.can_update_memo,
})

export interface IOtaReservationUpdateParams {
  custom_booker_name?: string | null
  custom_guest_name?: string | null
  customer_email?: string | null
  pickup_location?: string
  pickup_latitude?: string | number | null
  pickup_longitude?: string | number | null
  meetup_place_id?: number | null
  custom_meetup_point?: string | null
  custom_meetup_point_url?: string | null
}

export interface IOtaReservationMemoUpdateParams {
  memo?: string | null
  internal_memo?: string | null
}

export interface ISaveResult<T> {
  value: T
  saved: boolean
  canceled?: boolean
}
